const Analytics = {
  provider: process.env?.NX_PUBLIC_ANALYTICS_PROVIDER,
  trackingId: process.env?.NX_PUBLIC_GA_ID,
  containerId: process.env?.NX_PUBLIC_GTM_ID,
};

export default Analytics;
